import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { bootstrapClient } from '@/lib/api/bootstrap-client';
import type { BootstrapJobsListResponse, DownloadUrlsResponse } from '@/lib/types/bootstrap';

interface BootstrapJobsParams {
  page?: number;
  page_size?: number;
  tenant_id?: string;
  provider?: string;
  status?: string;
  sort_by?: string;
  sort_direction?: 'asc' | 'desc';
}

export function useBootstrapJobs(params?: BootstrapJobsParams) {
  return useQuery({
    queryKey: ['bootstrap-jobs', params],
    queryFn: async () => {
      const response = await bootstrapClient.get<BootstrapJobsListResponse>('/management/jobs', {
        params,
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
  });
}

export function useBootstrapJobDownloadUrls(jobId: string | null) {
  return useQuery({
    queryKey: ['bootstrap-job-download-urls', jobId],
    queryFn: async () => {
      const response = await bootstrapClient.get<DownloadUrlsResponse>(
        `/management/jobs/${jobId}/download-urls`,
      );
      return response.data;
    },
    enabled: !!jobId,
  });
}
